import { gql } from '@apollo/client/core';

export const USER_LOGGED_IN_MUTATION = gql`
  mutation userLoggedIn($description: String!) {
    userLoggedIn(description: $description) {
      status
      message
    }
  }
`;

export const USER_LOGGED_OUT_MUTATION = gql`
  mutation userLoggedOut($firebaseUid: String!, $description: String!) {
    userLoggedOut(firebaseUid: $firebaseUid, description: $description) {
      status
      message
    }
  }
`;

export const WHITELIST_MUTATION = gql`
  mutation whitelist($input: WhitelistMutationInput!) {
    whitelist(input: $input) {
      whitelist {
        firstName
      }
    }
  }
`;

export const UNSUBSCRIBE_MUTATION = gql`
  mutation unsubscribeFromAllEmails {
    unsubscribeFromAllEmails {
      status
      message
    }
  }
`;
